module.exports = __webpack_public_path__ + "static/img/patrowlhears-homepage.b146790f.png";